import { Box, Grid, Typography } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';

const useStyles = makeStyles({
  gridItem: { margin: 8 },
  formContainer: { 
    padding: 16
  },
  sectionTitle: {
    marginBottom: 16
  }
});

interface FormData {
  enderecoLocal: string;
  nomeContato: string;
  telefoneContato: string;
  emailContato: string;
  dataRecolha: string;
}

export default function InformacoesLocal() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<FormData>({
    enderecoLocal: '',
    nomeContato: '',
    telefoneContato: '',
    emailContato: '',
    dataRecolha: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosLocal',
      payload: { dadosLocal: formData }
    });
  }, [formData, dispatch]);

  return (
    <Box className={classes.formContainer}>
      <Typography variant="h5" className={classes.sectionTitle}>
        INFORMAÇÕES DO LOCAL DE RECOLHA
      </Typography>

      <Grid container spacing={2}>
        {/* Primeira linha: Endereço do local (ocupa toda largura) */}
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            label="Nome e endereço do lugar onde foi recolhido a amostra"
            fullWidth
            multiline
            rows={2}
            size="small"
            name="enderecoLocal"
            variant="outlined"
            onChange={handleChange}
            value={formData.enderecoLocal}
          />
        </Grid>

        {/* Subtítulo para informações de contato */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" style={{ marginTop: 16, marginBottom: 8 }}>
            Pessoa de contacto no local:
          </Typography>
        </Grid>

        {/* Segunda linha: Nome do contato (ocupa toda largura) */}
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            label="Nome"
            fullWidth
            size="small"
            name="nomeContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.nomeContato}
          />
        </Grid>

        {/* Terceira linha: Telefone e Email (lado a lado) */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="tel"
            label="Nº Telefone"
            fullWidth
            size="small"
            name="telefoneContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.telefoneContato}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="email"
            label="Email"
            fullWidth
            size="small"
            name="emailContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.emailContato}
          />
        </Grid>

        {/* Quarta linha: Data da recolha (ocupa metade da largura) */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            type="date"
            label="Data da recolha"
            fullWidth
            size="small"
            name="dataRecolha"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onChange={handleChange}
            value={formData.dataRecolha}
          />
        </Grid>
      </Grid>
    </Box>
  );
}